import React from "react";
import { TypeBadgeGroup } from "./components/TypeBadgeGroup";
import { TypeText } from "./components/TypeText";
import { TAlertProps } from "./types";

const Alert = (props: TAlertProps) => {
    if (props.type === "text") {
        return <TypeText {...props} />;
    }

    if (props.type === "badge-group") {
        return <TypeBadgeGroup {...props} />;
    }

    return null;
};

export default Alert;
